import React, { useState, useEffect } from 'react'
import { ErrorPage } from './errorPage/ErrorPage'
import ErrorFlag from '../../assets/icons/error-flag.svg'

interface ErrorBoundaryProps {
    children: React.ReactNode
}

export const ErrorBoundary: React.FC<ErrorBoundaryProps> = ({ children }) => {
    const [hasError, setHasError] = useState(false)

    useEffect(() => {
        const handleError = (event: ErrorEvent) => {
            setHasError(true)
            console.error('error:', event.error)
        }

        window.addEventListener('error', handleError)

        return () => {
            window.removeEventListener('error', handleError)
        }
    }, [])

    if (hasError) {
        return (
            <ErrorPage
                text1={'Oops! Something went wrong'}
                text2={'Please try again after sometime'}
                errorSVG={ErrorFlag}
                btnTitle={'Try Again'}
                onClick={() => window.location.reload()}
            />
        )
    }

    return <>{children}</>
}
